import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function WD_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="  pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <WD_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <WD_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function WD_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What programming languages should I learn for web development?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Commonly recommended languages include HTML, CSS, and JavaScript
              for front-end development. For back-end development, languages
              like Python, Ruby, PHP, Java, and Node.js are popular choices.
              Additionally, SQL for database management is essential.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What is the difference between front-end and back-end development?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Front-end development focuses on the user interface and user
              experience, involving everything that users interact with directly
              in their web browsers. Back-end development, on the other hand,
              deals with the server-side of applications, including databases,
              server logic, and application programming interfaces (APIs).
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How do I build a portfolio as a web developer?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Start by creating personal projects that showcase your skills,
              such as websites or web applications. Include a variety of work,
              demonstrating different technologies and techniques. You can also
              contribute to open-source projects or freelance work. Ensure your
              portfolio is accessible online, with clear descriptions of each
              project and your role.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What are the most in-demand skills for web developers?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              In addition to core languages like HTML, CSS, and JavaScript,
              skills in frameworks (e.g., React, Angular, Vue.js), version
              control (e.g., Git), responsive design, and knowledge of APIs and
              databases (e.g., REST, GraphQL, MongoDB) are highly sought after.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How do I stay updated with the latest web development trends and
              technologies?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Follow industry blogs, participate in online communities (like
              Stack Overflow or Reddit), attend webinars, and engage with
              developer conferences. Additionally, platforms like Codecademy,
              freeCodeCamp, and Udemy offer courses on new technologies and
              trends.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  )
}

export default WD_FAQ_page
